define('lq/formSubmission',[],function () {
    'use strict';

    var FormSubmission = function (url, target) {
        this.form = document.createElement('form');
        this.form.setAttribute('method', 'post');
        this.form.setAttribute('action', url);

        if (target)
            this.form.setAttribute('target', target);
    };

    FormSubmission.prototype.addProperty = function (name, value) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', name);
        hiddenField.setAttribute('value', value);
        this.form.appendChild(hiddenField);
    };

    FormSubmission.prototype.addParameters = function(name, parameters) {
        this.addProperty(name, JSON.stringify(parameters));
    };

    FormSubmission.prototype.submit = function () {
        document.body.appendChild(this.form);
        this.form.submit();
    };

    return FormSubmission;
});
